import { useEffect, useState } from "react";
import loadWebpImage from "utils/loadWebpImage";
import * as S from "./AchievementsOur.style";

const AchievementsOurCards = ({
    image,
    imageFallback,
    title,
    paragraph,
    Backgroundcolor,
}) => {
    const [imageCard, setImageCard] = useState();

    useEffect(() => {
        loadWebpImage(image, imageFallback, setImageCard);
    }, []);

    return (
        <S.CardAchievementsOur>
            <S.ImageCardAchievementsOur src={imageCard} />
            <S.ContentCardAchievementsOur colorBackground={Backgroundcolor}>
                <S.TitleCardAchievementsOur>{title}</S.TitleCardAchievementsOur>
                <S.ParagraphCardAchievementsOur>
                    {paragraph}
                </S.ParagraphCardAchievementsOur>
            </S.ContentCardAchievementsOur>
        </S.CardAchievementsOur>
    );
};

export default AchievementsOurCards;
